//tokens.js



// tokens.js
import usdtIcon from "../../../assets/icons/tokens/usdt.svg";
import usdcIcon from "../../../assets/icons/tokens/usdc.svg";
import ethIcon from "../../../assets/icons/tokens/eth.svg";
import bnbIcon from "../../../assets/icons/tokens/bnb.svg";
import maticIcon from "../../../assets/icons/tokens/matic.svg";
import usdeIcon from "../../../assets/icons/tokens/usde.svg";
import arbIcon from "../../../assets/icons/tokens/arb.svg"; // если есть

import chainEthIcon from "../../../assets/icons/chains/ethereum.svg";
import chainBscIcon from "../../../assets/icons/chains/bsc.svg";
import chainPolygonIcon from "../../../assets/icons/chains/polygon.svg";
import chainArbIcon from "../../../assets/icons/chains/arbitrum.svg";

export const TOKEN_ICONS = {
  USDT: usdtIcon,
  USDC: usdcIcon,
  USDE: usdeIcon,
  ETH: ethIcon,
  BNB: bnbIcon,
  MATIC: maticIcon,
  POL: maticIcon,   // если где-то показываешь POL
  ARB: arbIcon,     // токен ARB
};

export const CHAIN_ICONS = {
  1: chainEthIcon,
  56: chainBscIcon,
  137: chainPolygonIcon,
  42161: chainArbIcon,
};

export function getTokenIcon(symbol) {
  return TOKEN_ICONS[String(symbol || "").toUpperCase()] || "";
}

export function getChainIcon(chainId) {
  return CHAIN_ICONS[Number(chainId)] || "";
}


// 0x native token "address" (обязателен для 0x sellToken/buyToken)
export const OX_NATIVE = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";

// Разрешённые сети (как на бэке)
export const SUPPORTED_CHAINS = [1, 56, 137, 42161];

// Канонический USDT по сетям (как на бэке STABLE_BY_CHAIN)
export const STABLE_BY_CHAIN = {
  1:   "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  56:  "0x55d398326f99059fF775485246999027B3197955",
  137: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
  42161:"0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
};

// Реальные decimals USDT по сетям (как на бэке STABLE_DECIMALS_BY_CHAIN)
export const STABLE_DECIMALS_BY_CHAIN = {
  1: 6,
  56: 18,
  137: 6,
  42161: 6,
};

// USDC по сетям
export const USDC_BY_CHAIN = {
  1:   "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48", // Ethereum USDC (6)
  56:  "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d", // BSC USDC (18)
  137: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174", // Polygon USDC (6)
  42161:"0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8", // Arbitrum USDC.e (6)
};

// decimals USDC по сетям
export const USDC_DECIMALS_BY_CHAIN = {
  1: 6,
  56: 18,
  137: 6,
  42161: 6,
};

/* ===== TOKENS (без decimals) =====
   Allowlist токенов для UI.
*/
export const TOKENS_BY_CHAIN = {
  1: [
    { symbol: "ETH",  address: OX_NATIVE, isNative: true },
    { symbol: "USDT", address: STABLE_BY_CHAIN[1] },
    { symbol: "USDC", address: USDC_BY_CHAIN[1] },
    { symbol: "USDe", address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3" },
  ],
  56: [
    { symbol: "BNB",  address: OX_NATIVE, isNative: true },
    { symbol: "USDT", address: STABLE_BY_CHAIN[56] },
    { symbol: "USDC", address: USDC_BY_CHAIN[56] },
  ],
  137: [
    { symbol: "MATIC", address: OX_NATIVE, isNative: true },
    { symbol: "USDT",  address: STABLE_BY_CHAIN[137] },
    { symbol: "USDC",  address: USDC_BY_CHAIN[137] },
  ],
  42161: [
    { symbol: "ETH",  address: OX_NATIVE, isNative: true },
    { symbol: "USDT", address: STABLE_BY_CHAIN[42161] },
    { symbol: "USDC", address: USDC_BY_CHAIN[42161] },
  ],
};

export const USDE_BY_CHAIN = {
  1: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
};

export const USDE_DECIMALS_BY_CHAIN = {
  1: 18,
};

export const CHAIN_META = {
  1: { name: "Ethereum", nativeSymbol: "ETH" },
  56: { name: "BNB Chain", nativeSymbol: "BNB" },
  137: { name: "Polygon", nativeSymbol: "POL" }, // или "MATIC" если вы так показываете
  42161: { name: "Arbitrum", nativeSymbol: "ETH" },
};

// ===== Deposit symbol mapping =====
// Для депозитов отправляем символ, который понимает ваш бек (он нормализует, но так чище).
export function toDepositTokenSymbol(chainId, tokenSymbol) {
  const sym = String(tokenSymbol || "").toUpperCase();

  // Polygon: в UI у вас MATIC, но в meta вы хотите POL.
  // Бэк понимает и MATIC и POL, но будем отправлять POL.
  if (Number(chainId) === 137 && sym === "MATIC") return "POL";

  return sym;
}
